import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionConsumePackage, TypeActionPackages } from "../actionPackages";
export var epicConsumePackages = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPackages.ConsumePackages), switchMap(function (action) {
        var actions = [];
        for (var _i = 0, _a = action.packagesInfo; _i < _a.length; _i++) {
            var _b = _a[_i], packageId = _b.packageId, amount = _b.amount;
            actions.push(actionConsumePackage(packageId, amount));
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/item-packages/epics/epicConsumePackages.ts
// module id = 1977
// module chunks = 3